import { createStore } from '@stencil/store';

export const Store = createStore({
  activeView: 'home',
  isSessionActive: false,
  accountName: 'Tuhin Bhuyan',
  accountEmail: '',
  accountMode: 'standard' as 'standard' | 'demo',
  accountCreatedAt: '',
  isEmailVerified: true,
  isGoogleOauthLinked: false,
  hasPassword: true,
  currentLocation: 'IN',
  oauthToken: '',
  csrfToken: '',
  hcaptchaSiteKey: '',
  // Billing state
  accountTier: null as any,
  subscription: null as any,
  usage: null as any,
  billingConfig: null as any,
  billingLoaded: false,
}).state;
